import api from '@pray/shared/utils/api';

export interface SeriesTag {
  id: string;
  name: string;
  description: string | null;
  is_suggested: boolean;
  priority: number | null;
}

export interface GetSeriesTagsResponse {
  data: SeriesTag[];
}

export interface GetSeriesTagsParams {
  artistId: string;
  seriesId: string;
}

/**
 * Get all tags for a content series
 */
export async function getSeriesTags({ artistId, seriesId }: GetSeriesTagsParams): Promise<GetSeriesTagsResponse> {
  const url = `/web/studio/artists/${artistId}/content-series/${seriesId}/tags`;
  const response = await api.executeGetRequest<GetSeriesTagsResponse>(url);
  return response.data;
}
